<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import Filter from "../../Email/Components/filter.svelte"

  let showFilter = false

  let filterDiv

  /**
   * function to close the dropdown on click anywhere in window
   * @param e-targetting binded value to close drop down
   */
  const onCloseDropDown = (e) => {
    if (filterDiv.contains(e.target) == false) showFilter = false
  }
</script>

<svelte:window on:click={onCloseDropDown} />
<div bind:this={filterDiv}>
  <button
    data-tooltip="Filter Analytics"
    tooltip-position="left"
    on:click={() => {
      showFilter = !showFilter
    }}
    class="flex h-9 min-h-full w-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-800 hover:bg-green-500 hover:text-white focus:outline-none active:bg-green-600 active:text-white disabled:cursor-not-allowed dark:bg-darkgray dark:text-slate-200 dark:hover:bg-green-500"
  >
    <i class="fa-solid fa-filter" />
  </button>
  <div class:hidden={!showFilter} class="absolute top-12 right-0 z-30">
    <Filter
      on:reset
      on:changeEntries={(e) => {
        dispatch("entriesChanged", e.detail)
      }}
      bind:showFilterForm={showFilter}
    />
  </div>
</div>
